var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"config-public-job-board container-md col-lg-8 col-md-"},[_c('PublicJobBoardConfig')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }